import React, { useState, useEffect, useRef } from 'react';
import '../../../gcsp/styles/styles.css';
import TableHeader from '../../../../molecules/dcsp/components/tableHeader';

import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';
import { useMemo } from 'react';
import {
  getGCSPPastOpportunitiesMonthly,
  getGCSPPastOpportunitiesQuaterly,
} from '../../../../../services/gcspServices';
import { AG_GRID_LICENSE_KEY } from '../../../../../constants/licenseKeys';
import { useRecoilState } from 'recoil';
import { Gcsp_Past_Opp_View_State } from '../../../../../recoil/recoil';

import { MotifChip } from '@ey-xd/motif-react';
import wonIcon from '../../../../assets/icons/medal.png';
import openIcon from '../../../../assets/icons/dashed_circle.png';
import lostIcon from '../../../../assets/icons/block_circle.png';
import {
  TableData1C,
  TableData1CBold,
  PLPastStatusCell,
} from '../../../../atoms/tableData/styles/tableData.styles';

import {
  abbreviatedMonthList,
  QUARTERLY_DETAILS,
  TABLE_HEADER_SUBTEXT,
} from '../../../../../constants/commonConstants';
import { DateFiltering, OppsNameSorting } from '../../../../../util/commonFunctions';
import GcspPastTableData from './gcspPastTableData';

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
let gridApi;

const GcspPastTable = props => {
  let TYPE = props.forecast_type;
  let EMAIL = props.email;
  let MONTH = props.month;
  let YEAR = props.year;
  let ACCOUNT_ID = props.account;
  let QUARTER = props.quarter;
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Past_Opp_View_State);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [showNowRowsToShowText, setShowNowRowsToShowText] = useState(true);

  useEffect(() => {
    setRowData([]);
    setShowNowRowsToShowText(true);

    const fetchData = async () => {
      try {
        let getOpportunitiesDetailsAPI =
          TYPE === 'month'
            ? await getGCSPPastOpportunitiesMonthly(EMAIL, ACCOUNT_ID, MONTH, YEAR, TYPE, QUARTER)
            : TYPE === 'quarter'
              ? await getGCSPPastOpportunitiesQuaterly(
                  EMAIL,
                  ACCOUNT_ID,
                  MONTH,
                  YEAR,
                  TYPE,
                  QUARTER,
                )
              : null;

        if (getOpportunitiesDetailsAPI) {
          setGcspOppViewData(getOpportunitiesDetailsAPI);
          let opppData = getOpportunitiesDetailsAPI.Committed.concat(
            getOpportunitiesDetailsAPI.Not_Committed,
            getOpportunitiesDetailsAPI.Missed,
          );
          setShowNowRowsToShowText(false);
          setRowData(opppData);
          // To show text 'No rows to show'
        }
      } catch (error) {
        console.error('Error:', error);
        // To show text 'No rows to show'
        setShowNowRowsToShowText(false);
      }
    };
    fetchData();
  }, [TYPE, EMAIL, MONTH, YEAR, ACCOUNT_ID, QUARTER]);

  const getRowStyle = params => {
    // if (params.node.key == 'Committed' || params.node.parent.key == 'Committed') {
    if (params.node.group == true) {
      // For row groups
      return { background: '#ffffff' };
    } else {
      // For inner elements
      return { background: '#eaeaf2' };
    }
  };

  const TextCellRendererCBold = ({ value }) => <TableData1CBold>{value}</TableData1CBold>;

  const CommitStatusCellRenderer = props => {
    if (props.value === 'Committed') {
      return (
        <MotifChip variant="success" type="dot">
          {QUARTERLY_DETAILS.COMMITTED}
        </MotifChip>
      );
    } else if (props.value === 'Not Committed') {
      return (
        <MotifChip variant="disabled" type="dot">
          {QUARTERLY_DETAILS.NOT_COMMITTED}
        </MotifChip>
      );
    } else {
      return (
        <MotifChip variant="warning" type="dot">
          {QUARTERLY_DETAILS.MISSED}
        </MotifChip>
      );
    }
  };

  const StatusCellRenderer = props => {
    if (props.node.group == true) {
      let count = 0;
      for (let i = 0; i < props.node.childrenAfterAggFilter.length; i++) {
        if (props.node.childrenAfterAggFilter[i].data.Status == 1) {
          count++;
        }
      }
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
          }}
        >
          <PLPastStatusCell>
            <img src={wonIcon} width={18} height={18} />
            <TableData1C>{count}</TableData1C>
            <TableData1C>{QUARTERLY_DETAILS.WON}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    }
    if (props.value == '0') {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
          }}
        >
          <PLPastStatusCell>
            <img src={openIcon} />
            <TableData1C>{QUARTERLY_DETAILS.OPEN}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else if (props.value == '1') {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
          }}
        >
          <PLPastStatusCell>
            <img src={wonIcon} width={18} height={18} />
            <TableData1C>{QUARTERLY_DETAILS.WON}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else if (props.value == '2') {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
          }}
        >
          <PLPastStatusCell>
            <img src={lostIcon} />
            <TableData1C>{QUARTERLY_DETAILS.LOST}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else if (props.value == '3') {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '100%',
          }}
        >
          <PLPastStatusCell>
            <img src={lostIcon} />
            <TableData1C>{QUARTERLY_DETAILS.DECLINED}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const DateCellRenderer = props => {
    if (props.node.group !== true) {
      const date = props.value;
      const month = props.Month;

      if (date === null) {
        return <TableData1C>-</TableData1C>;
      }
      if (date === undefined) {
        return <TableData1C></TableData1C>;
      } else {
        const month_array = abbreviatedMonthList;

        let isoDate = new Date(date);
        const timeZoneOffsetMinutes = isoDate.getTimezoneOffset();
        isoDate = new Date(isoDate.getTime() + timeZoneOffsetMinutes * 60000);

        let derivedMonth = month_array[isoDate.getMonth()];
        let derivedDate = isoDate.getDate();
        let derivedYear = isoDate.getFullYear();
        if (derivedDate < 10) {
          derivedDate = `0${derivedDate}`;
        }
        let final_date = `${derivedDate} ${derivedMonth} ${derivedYear} (${month}) `;
        return <TableData1C>{final_date}</TableData1C>;
      }
    }
    return <TableData1C> </TableData1C>;
  };

  const groupRowRenderer = params => {
    return params.node.group
      ? `Custom Group: ${params.node.key}`
      : params.data[params.colDef.field];
  };

  const MoneyAggFunc = params => {
    let total = 0;
    params.values.forEach(value => (total += value));
    return total;
  };

  const MoneyCellRenderer = props => {
    if (props.is_first_node) {
      let formattedValue = Number(props.value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return <TableData1C>{formattedValue}</TableData1C>;
    } else {
      const old_value = props.old_value;
      const new_value = props.new_value;
      let formattedValue1 = Number(new_value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      let formattedValue2 = Number(old_value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      if (formattedValue1 === formattedValue2) {
        return <TableData1C>{formattedValue1}</TableData1C>;
      } else {
        return (
          <TableData1C>
            {formattedValue1} (<s>{formattedValue2}</s>)
          </TableData1C>
        );
      }
    }
  };

  const MoneyCellRenderer2 = props => {
    let service_line = props.service_line;
    let service_line_latest = props.service_line_latest;
    let new_value = 0;
    let old_value = 0;
    if (props.node.group == true) {
      for (let i = 0; i < props.node.childrenAfterAggFilter.length; i++) {
        new_value += props.node.childrenAfterAggFilter[i].data[service_line_latest];
        old_value += props.node.childrenAfterAggFilter[i].data[service_line];
      }
    } else {
      old_value = props.node.data[service_line];
      new_value = props.node.data[service_line_latest];
    }
    let formattedValue1 = Number(new_value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    let formattedValue2 = Number(old_value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    if (formattedValue1 === formattedValue2) {
      return <TableData1C>{formattedValue1}</TableData1C>;
    } else {
      return (
        <TableData1C>
          {formattedValue1} (<s>{formattedValue2}</s>)
        </TableData1C>
      );
    }
  };
  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: 'PL Commit Status',
      // minWidth: 300,
      field: 'category',
      headerComponentParams: {
        enableMenu: false,
        enableSorting: false,
      },
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: CommitStatusCellRenderer,
      },
      suppressMovable: true,
    };
  }, []);

  const menuTabsItems = ['filterMenuTab'];

  const columnDefs = [
    {
      headerName: 'PL Commit Status',
      showRowGroup: true,
      rowGroup: true,
      hide: true,
      field: 'category',
      cellRenderer: CommitStatusCellRenderer,
      width: 150,
      suppressMovable: true,
    },
    {
      headerName: 'Status',
      field: 'Status',
      headerComponentParams: {
        enableSorting: false,
        enableMenu: true,
      },
      cellRenderer: StatusCellRenderer,
      width: 120,
      menuTabs: menuTabsItems,
      filter: 'agTextColumnFilter',
      suppressMovable: true,
    },
    {
      headerName: 'ID',
      field: 'ey_id',
      filter: true,
      headerComponentParams: {
        enableSorting: false,
        enableMenu: true,
      },
      cellRenderer: TextCellRendererCBold,
      width: 120,
      menuTabs: menuTabsItems,
      filter: 'agTextColumnFilter',
      suppressMovable: true,
    },

    {
      headerName: 'Opportunity Name',
      field: 'opportunityname',
      filter: true,
      headerComponentParams: {
        enableSorting: true,
        enableMenu: true,
      },
      width: 200,
      menuTabs: menuTabsItems,
      filter: 'agTextColumnFilter',
      suppressMovable: true,
      comparator: OppsNameSorting,
    },

    {
      headerName: 'Eff. Close Date',
      field: 'ECD',
      sortable: true,
      filter: true,
      cellRenderer: DateCellRenderer,
      headerComponentParams: {
        enableSorting: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      cellRendererParams: params => {
        if (params.node.group !== true) {
          const Month = params.data.ECD_month;
          return { Date, Month };
        }
      },
      // aggFunc: params => {return undefined},
      width: 200,
      menuTabs: menuTabsItems,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      suppressMovable: true,
    },
    {
      headerName: 'AWD',
      field: 'AWD',
      sortable: true,
      filter: true,
      cellRenderer: DateCellRenderer,
      headerComponentParams: {
        enableSorting: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      cellRendererParams: params => {
        if (params.node.group !== true) {
          const Month = params.data.AWD_month;
          return { Date, Month };
        }
      },
      // aggFunc: params => {return undefined},
      width: 200,
      menuTabs: menuTabsItems,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      suppressMovable: true,
    },
    {
      headerName: 'Pursuit Leader',
      field: 'PursuitLeader',
      filter: true,
      headerComponentParams: {
        enableSorting: false,
        enableMenu: true,
      },
      width: 200,
      menuTabs: menuTabsItems,
      filter: 'agTextColumnFilter',
      suppressMovable: true,
    },
    {
      headerName: 'Assurance',
      field: 'Assurance_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'Assurance',
        enableSorting: true,
        enableMenu: false,
        subText: TABLE_HEADER_SUBTEXT.EXCL_ACR,
        subText2: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellStyle: { textAlign: 'right' },
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'Assurance_latest';
        const service_line = 'Assurance';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'Consulting',
      field: 'consulting_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'Consulting',
        enableSorting: true,
        enableMenu: false,
        subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellStyle: { textAlign: 'right' },
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'consulting_latest';
        const service_line = 'consulting';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'SAT',
      field: 'sat_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'SAT',
        enableSorting: true,
        enableMenu: false,
        subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
        subText2: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'sat_latest';
        const service_line = 'sat';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'Tax',
      field: 'tax_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'Tax',
        enableSorting: true,
        enableMenu: false,
        subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
        subText2: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'tax_latest';
        const service_line = 'tax';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'ITTS',
      field: 'itts_latest',
      // sortable: true,
      headerComponentParams: {
        displayName: 'ITTS',
        enableMenu: false,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'itts_latest';
        const service_line = 'itts';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'EMEIA ACR',
      field: 'EMIAACR_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'EMEIA ACR',
        enableMenu: false,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'EMIAACR_latest';
        const service_line = 'EMIAACR';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
    {
      headerName: 'TOV',
      field: 'TOV_latest',
      sortable: true,
      headerComponentParams: {
        displayName: 'TOV',
        enableMenu: false,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 175,
      cellClass: 'cell-text-aligment',
      cellRenderer: MoneyCellRenderer2,
      cellRendererParams: params => {
        const service_line_latest = 'TOV_latest';
        const service_line = 'TOV';
        return { service_line_latest, service_line };
      },
      suppressMovable: true,
    },
  ];

  const handleGridReady = params => {
    ({ api: gridApi } = params);
  };

  return (
    <>
      <div
        className="ag-theme-alpine"
        style={{
          maxWidth: 1920,
          flex: 2,
          height: 365,
        }}
      >
        <AgGridReact
          ref={gridRef}
          firstColumnBorderRight
          columnDefs={columnDefs}
          rowData={rowData}
          groupDisplayType={'singleColumn'}
          showOpenedGroup={true}
          suppressHorizontalScroll={true}
          autoGroupColumnDef={autoGroupColumnDef}
          // groupRowRenderer={groupRowRenderer}
          onGridReady={handleGridReady}
          headerHeight={70}
          headerCellWidth={200}
          components={{
            agColumnHeader: TableHeader,
          }}
          getRowStyle={getRowStyle}
          overlayNoRowsTemplate={showNowRowsToShowText ? 'Loading...' : 'No Rows To Show'}
        />
      </div>
      <GcspPastTableData refValue={gridRef} />
    </>
  );
};

export default GcspPastTable;
